import helpers from "./helpers"
import { KMSClient, EncryptCommand, DecryptCommand } from "@aws-sdk/client-kms";
import { Buffer } from "buffer";


const clientParams = {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
};

const config = {
    credentials: clientParams,
    endPoint: "",
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
    signatureVersion: 2,
    region: process.env.REACT_APP_AWS_REGION,
};

const client = new KMSClient(config);

export const getMediaSchemaMarkup = (data, actors, crewData) => {
    let directorData = crewData?.results && crewData.results.length > 0 ? crewData.results.filter(x => x?.role == 'Director') : null;
    let producerData = crewData?.results && crewData.results.length > 0 ? crewData.results.filter(x => x?.role == 'Producer') : null;

    const { trailer } = data;
    let trailerData = trailer && trailer?.name ? `{
        "@type": "VideoObject",
        "name": "${trailer?.name}",
        "description": "${trailer?.type}",
        "embedUrl": "https://www.youtube.com/watch?v=${trailer?.key}",
        "thumbnailUrl" : "https://img.youtube.com/vi/${trailer?.key}/0.jpg",
        "uploadDate": "${trailer?.published_at || data?.release_date || new Date().toISOString()}"
    }` : '""';

    let actor = actors && actors.length > 0 ?
        actors.map(x => {
            return `{
                "@type": "PerformanceRole",
                "actor": {
                    "@type": "Person",
                    "name": "${x?.name}",
                    "url": "https://myfrenzi.com/person/${x?.unique_title || x?.name.replace(/ /g, "-")}${x?.unique_title ? "" : "/" + x?.uuid}",
                    "image": "${x?.poster}"
                },
                "characterName":"${x?.character || x?.name}"
            }`
        })
        :
        '';


    let director = directorData && directorData[0] ?
        `{
                "@type": "Person",
                "name": "${directorData[0]?.name}",
                "url": "https://myfrenzi.com/person/${directorData[0]?.unique_title || directorData[0]?.name.replace(/ /g, "-")}${directorData[0]?.unique_title ? "" : "/" + directorData[0]?.uuid}",
                "image": "${directorData[0]?.poster}"
            }`
        :
        '';

    let producer = producerData && producerData[0] ?
        `{
                "@type": "Person",
                "name": "${producerData[0]?.name}",
                "url": "https://myfrenzi.com/person/${producerData[0]?.unique_title || producerData[0]?.name.replace(/ /g, "-")}${producerData[0]?.unique_title ? "" : "/" + producerData[0]?.uuid}",
                "image": "${producerData[0]?.poster}"
            }`
        :
        '';

    let genre = data?.genres && data?.genres[0] && data?.genres.map(x => x.name);

    let results = `{
        "@context": "http://schema.org",
        "@id": "${window.location.href}",
        "@type": "${data?.media_type === 'movie' ? "Movie" : "TVSeries"}",
        "name": "${data?.title}",
        "description": "${data?.media_overview}",
        "genre": ${genre ? JSON.stringify(genre) : ""},
        "datePublished": "${data?.release_date}",
        "dateCreated": "${data?.release_date}",
        "image": "${data?.poster_path && data?.poster_path != ""
            ? helpers.getFullUrl(data?.poster_path)
            : helpers.getDefaultImage("poster")}",
        "director": ${director || '"N/A"'},
        "producer": ${producer || '"N/A"'},
        "actor": [${actor}],
        "duration": "${helpers.convertMinutesToDuration(data?.movie_runtime) || "N/A"}",
        "trailer": ${trailerData},
        "review": ${data?.review_counts}
    }`;

    if (data?.media_type === 'movie') {
        return results;
    } else {
        if (helpers.isValidJSON(results)) {
            let temp = JSON.parse(results);
            delete temp.duration;
            return JSON.stringify(temp);
        } else {
            return results;
        }
    }
}

export const getActorSchemaMarkup = (data) => {
    if (data && data.name) {
        return `{
        "@context": "http://schema.org",
        "@type": "Person",
        "name": "${data?.name}",
        "birthDate": "${data?.birthday || ""}",
        "description": "${data?.biography}",
        "jobTitle": "${data?.known_for_department}",
        "url": "https://myfrenzi.com/person/${data?.unique_title || data?.name.replace(/ /g, "-")}${data?.unique_title ? "" : "/" + data?.uuid}",
        "image": "${data?.poster ? helpers.getFullUrl(data?.poster) : ""}"
    }`;
    } else {
        return '';
    }
}

export const isMobileDevice = (userAgent) => {
    let ua = (userAgent || navigator.userAgent).toLowerCase();
    const isMobile = (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| ||a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4)) || /ipad|iphone|iPod|android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i.test(ua));
    return isMobile;
}

export const getGoogleCastData = (ottData, data) => {

    let mesgData = {
        deep_link: ottData?.android_tv_deep_link || ottData?.deep_link,
        android_tv_package: ottData?.android_tv_package,
        platform_name: ottData?.platform_name
    }

    if (data && data?.title) {
        mesgData = {
            ...mesgData,
            poster: helpers.getFullUrl(data?.poster_path),
            title: data?.title,
            run_time: data?.movie_runtime ? helpers.getMovieRunTime(data?.movie_runtime) : '',
            media_type: data?.media_type,
            genre: data?.genres && data?.genres[0] ? data?.genres[0].name : '',
            ott_image: ottData?.platform_logo
        }
    }

    let mesg = JSON.stringify(mesgData);

    const scriptCode = `
var btnElement = document.getElementById("cast-button");
var initializeCastApi = function () {
  console.log("initializeCastApi");

  var sessionRequest = new chrome.cast.SessionRequest('7A040115');
  var apiConfig = new chrome.cast.ApiConfig(
    sessionRequest,
    sessionListener,
    receiverListener
  );
  chrome.cast.initialize(apiConfig, onInitSuccess, onError);
};

if (!chrome.cast || !chrome.cast.isAvailable) {
    setTimeout(initializeCastApi, 500);
}else{
    setTimeout(initializeCastApi, 500);
}

function onInitSuccess() {
  console.log("onInitSuccess");
}

function onError(e) {
  console.log("onError", e);
}

function onConnectError(e) {
    console.log("onError", e);
    document.getElementById("cast-error").style.display = 'block';
    document.getElementById("cast-error").innerHTML = e?.description;
  }

function sessionListener(e) {
  console.log("sessionListener", e);
}

function receiverListener(availability) {
  console.log("receiverListener", availability);

  if (availability === chrome.cast.ReceiverAvailability.AVAILABLE) {
    document.getElementById("cast-view").style.display = 'block';
  }
}

function onSessionRequestSuccess(session) {
    console.log("onSessionRequestSuccess", session);

    if (session && session.status === chrome.cast.SessionStatus.CONNECTED) {
        session.sendMessage("urn:x-cast:custom_namespace", ${mesg}, () => {
            console.log('Message sent successfully.');
            document.getElementById("cast-error").style.display = 'none';
            document.getElementById("scan-close").click();
        }, (error) => {
            console.error('Error sending message:', error);
            if(error?.description || error?.code){
                document.getElementById("cast-error").style.display = 'block';
                document.getElementById("cast-error").innerHTML = error?.description || error?.code;
            }else{
                document.getElementById("cast-error").style.display = 'none';
                document.getElementById("scan-close").click(); 
            }
        });
    }
}

function onMediaLoadSuccess(e) {
  console.log("onMediaLoadSuccess", e);
}

btnElement.onclick = function () {
    chrome.cast.requestSession(onSessionRequestSuccess, onConnectError);
};
`
    return scriptCode;

}


export const encryptData = async (formData) => {
    const encoder = new TextEncoder();
    var unit8String = encoder.encode(JSON.stringify(formData));
    const input = {
        KeyId: process.env.REACT_APP_AWS_ARN_KEY_ID,
        Plaintext: unit8String,
    };
    const command = new EncryptCommand(input);
    const response = await client.send(command);
    if (response && response.CiphertextBlob) {
        let buff = new Buffer(response.CiphertextBlob);
        let base64data = buff.toString("base64");
        return base64data;
    } else {
        return formData;
    }
}

export const decryptDataSingle = async (responseText) => {
    var cipherText = await helpers._base64ToArrayBuffer(responseText);
    if (cipherText) {
        const input = {
            KeyId: process.env.REACT_APP_AWS_ARN_KEY_ID,
            CiphertextBlob: cipherText,
        };
        try {
            const command = new DecryptCommand(input);
            const response = await client.send(command);
            // process data.
            if (response && response.Plaintext) {
                let win1251decoder = new TextDecoder("windows-1251");
                let bytes = new Uint8Array(response.Plaintext);
                var decryptedText = win1251decoder.decode(bytes);
                var jsonData = JSON.parse(decryptedText);
                if (jsonData && !helpers.isEmptyObject(jsonData)) {
                    return jsonData;
                }
            } else {
                return responseText;
            }
        } catch (error) {
            return responseText;
        }
    } else {
        return responseText;
    }
}

export const decryptData = async (respData) => {
    if (typeof respData != 'string' && respData.length) {
        const decryptedChunks = await Promise.all(respData.map(async (responseText) => {
            var cipherText = await helpers._base64ToArrayBuffer(responseText);
            if (cipherText) {
                const input = {
                    KeyId: process.env.REACT_APP_AWS_ARN_KEY_ID,
                    CiphertextBlob: cipherText,
                };
                try {
                    const command = new DecryptCommand(input);
                    const response = await client.send(command);
                    // process data.
                    if (response && response.Plaintext) {
                        let win1251decoder = new TextDecoder("windows-1251");
                        let bytes = new Uint8Array(response.Plaintext);
                        var decryptedText = win1251decoder.decode(bytes);
                        return decryptedText;
                    } else {
                        return '';
                    }
                } catch (error) {
                    return '';
                }
            } else {
                return '';
            }
        }));

        var jsonData = JSON.parse(decryptedChunks.join(''));
        if (jsonData && !helpers.isEmptyObject(jsonData)) {
            return jsonData;
        } else {
            return false;
        }
    } else {
        return await decryptDataSingle(respData);
    }
}
